import requests from "./httpServices.js";

class AssetService {
  async listAssets(type = null, search = null) {
    try {
      const params = new URLSearchParams();
      if (type && type !== 'all') params.append('type', type);
      if (search) params.append('search', search);
      const query = params.toString();
      const url = `/element/assets${query ? `?${query}` : ''}`;
      const response = await requests.get(url);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async createAsset(data) {
    try {
      const response = await requests.post('/element/assets', data);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async deleteAsset(id) {
    try {
      const response = await requests.delete(`/element/assets/${id}`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  handleError(error) {
    if (error.response?.data) {
      const { message, errors } = error.response.data;
      if (errors && typeof errors === "object") {
        const errorMessages = Object.values(errors).flat();
        return new Error(errorMessages.join(", "));
      }
      if (message) {
        return new Error(message);
      }
    }
    if (error.message) {
      return new Error(error.message);
    }
    return new Error("An unexpected error occurred");
  }
}

const assetService = new AssetService();
export default assetService;
